import React from "react";
import styled from "styled-components";
import { Colors, theme } from "../../theme";
import { Text } from "../Text/Text";
import { ErrorRequiredIcon } from "src/assets/Icon/Error/Error";

type FieldMessageProps = {
  children?: string;
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding: 0;

  > p {
    margin: 0;
  }
  color: ${theme(Colors.red[100], Colors.lightRed[100])};
`;

export function FieldMessage({ children }: FieldMessageProps) {
  return (
    <Container>
      <ErrorRequiredIcon size="medium" />
      <Text size="small">{children}</Text>
    </Container>
  );
}

export default FieldMessage;
